import { Link } from "react-router-dom/cjs/react-router-dom";

export default function Footer() {
  return (
    <footer style={{ background: "#0d1b4b" }}>
      <div className="max-w-5xl mx-auto px-4 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">

          {/* Brand */}
          <div>
            <p className="text-white font-bold text-lg">Katsina SDG</p>
          </div>

          {/* Head Office */}
          <div>
            <p className="font-semibold mb-4" style={{ color: "#4ade80" }}>Head Office</p>
            <p className="text-gray-300 text-sm leading-relaxed">
              Olusegun Obasanjo Drive, VIP Opp. Water Board GRA, Katsina, Katsina State.
            </p>
            {/* <p className="text-gray-300 text-sm mt-3">+234 814 957 8613</p> */}
            <p className="text-gray-300 text-sm mt-1">info@sdgskatsina.org</p>
          </div>

          {/* Quick links */}
          <div>
            <p className="font-semibold mb-4" style={{ color: "#4ade80" }}>Quick links</p>
            <ul className="flex flex-col gap-2">
              <li>
                <Link to="/" className="text-gray-300 text-sm hover:text-white no-underline">Home</Link>
              </li>
              <li>
                <a href="/#about" className="text-gray-300 text-sm hover:text-white no-underline">About Us</a>
              </li>
              <li>
                <Link to="/login" className="text-gray-300 text-sm hover:text-white no-underline">SDGs</Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <p className="font-semibold mb-4" style={{ color: "#4ade80" }}>Support</p>
            <ul className="flex flex-col gap-2">
              <li>
                <a href="mailto:info@sdgskatsina.org" className="text-gray-300 text-sm hover:text-white no-underline">Contact Us</a>
              </li>
              <li>
                <Link to="/login" className="text-gray-300 text-sm hover:text-white no-underline">Sign In</Link>
              </li>
            </ul>
          </div>

        </div>

        <div className="border-t border-gray-700 mt-10 pt-6 text-center">
          <p className="text-gray-400 text-xs">© {new Date().getFullYear()} Katsina State Project Support Unit. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
